import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { UserActionsModule } from '../user-actions/user-actions.module';
import { MenubarModule } from 'primeng/menubar';
import { RouterModule } from '@angular/router';
import { ThemeSwitcherModule } from '../theme-switcher/theme-switcher.module';
import { NotificationsMenuComponent } from '../notifications-menu/notifications-menu.component';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { SkeletonModule } from 'primeng/skeleton';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { FilterPanelComponent } from '../filter-panel/filter-panel.component';
import { SidebarIconComponent } from '../../../shared/ui/sidebar-icon/sidebar-icon.component';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    ButtonModule,
    SplitButtonModule,
    ToolbarModule,
    MenubarModule,
    UserActionsModule,
    RouterModule,
    ThemeSwitcherModule,
    NotificationsMenuComponent,
    TagModule,
    TooltipModule,
    SkeletonModule,
    FormsModule,
    SelectModule,
    MultiSelectModule,
    FilterPanelComponent,
    SidebarIconComponent,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
